import { QueryClient } from '@tanstack/react-query';

const queryClient: QueryClient = new QueryClient({
  defaultOptions: {
    queries: {
      throwOnError: false,
      refetchOnWindowFocus: false,
      retry: false,
      staleTime: Number(process.env.REACT_APP_API_STALE_TIME),
      // gcTime: Number(process.env.REACT_APP_API_GC_TIME),
    },
  },
});

export default queryClient;
